module.exports = " <button class=Button :class=\"{\n  red: color === 'red',\n  grey: color === 'grey',\n  yellow: color === 'yellow',\n  blue: color === 'blue'\n}\" _v-f1cabe5c=\"\"> <slot _v-f1cabe5c=\"\"></slot> </button> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-f1cabe5c!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Button.vue
// module id = 131
// module chunks = 2